/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable sort-vars */
/* eslint-disable sort-keys */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
import "./home.scss";
import "../../assets/scss/main.scss";
import {
  Avatar,
  Card,
  CardContent,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FolderList from "../../features/folderList/FolderList";
import DocumentOverview from "../../features/documents/DocumentOverview";
import SuggestedFiles from "../../features/documents/SuggestedFiles";
import SuggestedFolders from "../../features/documents/SuggestedFolders";

export default function Home() {
  return (
    <>

      <DocumentOverview />

      <SuggestedFiles />

      <SuggestedFolders />

    </>
  );
}
